/**
 * Temporary maintenance gate for the "pettoville" brand.
 *
 * Requirement: any request coming in on a pettoville domain must be sent to the
 * /close page from now until 00:30 (half past midnight) on 2026-09-08.
 * After the deadline this returns false and the app boots normally.
 *
 * To change / extend the window, edit CLOSE_UNTIL below.
 */

// 2026-09-08 00:30:00 +07:00 (Asia/Bangkok)
const CLOSE_UNTIL = new Date("2026-09-08T00:00:00+07:00").getTime();

const isPettovilleHost = () => {
  const hostname = (window.location.hostname || "").toLowerCase();
  return hostname.split("-")[0].split(".")[0] === "pettoville";
};

/**
 * @returns {boolean} true while pettoville should be forced to the close page
 */
export const isMaintenanceClosed = () =>
  isPettovilleHost() && Date.now() < CLOSE_UNTIL;

export { CLOSE_UNTIL, isPettovilleHost };
